var _style, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgHappensAtButchery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_26_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 285 263",
    style: {
      enableBackground: "new 0 0 285 263"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;}\n\t.st1{opacity:0.8;fill:url(#Path_671_00000079469539286433139950000007249859832536681883_);enable-background:new    ;}\n\t.st2{fill:#757575;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{opacity:0.7;fill:url(#Ellipse_111_00000104691517363214616860000010234985096905664414_);enable-background:new    ;}\n\t.st5{fill:#828282;}\n\t.st6{fill:#D2D2D2;}\n\t.st7{fill:#C0C0C0;}\n\t.st8{fill:#E4E4E4;}\n\t.st9{fill:#ACACAC;}\n\t.st10{fill:#B1B1B1;}\n\t.st11{fill:#C2C2C2;}\n\t.st12{fill:#848484;}\n\t.st13{fill:#595959;}\n\t.st14{fill:#878787;}\n\t.st15{fill:#F3F3F3;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 285,
    height: 133,
    id: "Path_786_00000116953818765061988420000018291675400578855053_",
    xlinkHref: "645BD4ED6F494D87.png",
    transform: "matrix(1 0 0 1 0 123)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    transform: "translate(-351.844 -103.58)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_671_00000050655284104779683680000004616038681196540086_",
    gradientUnits: "userSpaceOnUse",
    x1: -461.2906,
    y1: 774.6119,
    x2: -461.2906,
    y2: 773.6119,
    gradientTransform: "matrix(242.767 0 0 -206.795 112476.6406 160312.0469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.855
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.631
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.439
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.282
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.157
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.071
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    style: {
      opacity: 0.8,
      fill: "url(#Path_671_00000050655284104779683680000004616038681196540086_)",
      enableBackground: "new"
    },
    d: " M611.9,333H369.1l47.8-206.8h145.3L611.9,333z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_465",
    className: "st2",
    d: "M416.1,114h146.7c1.4,0,2.5,1.1,2.5,2.5v3.9c0,1.4-1.1,2.5-2.5,2.5H416.1 c-1.4,0-2.5-1.1-2.5-2.5v-3.9C413.6,115.1,414.7,114,416.1,114z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_466",
    className: "st2",
    d: "M423.1,103.6h2.6c0.4,0,0.8,0.4,0.8,0.8v9.9c0,0.4-0.4,0.8-0.8,0.8h-2.6 c-0.4,0-0.8-0.4-0.8-0.8v-9.9C422.3,103.9,422.6,103.6,423.1,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_467",
    className: "st2",
    d: "M465.6,103.6h2.6c0.4,0,0.8,0.4,0.8,0.8v9.9c0,0.4-0.4,0.8-0.8,0.8h-2.6 c-0.4,0-0.8-0.4-0.8-0.8v-9.9C464.8,103.9,465.2,103.6,465.6,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_468",
    className: "st2",
    d: "M508.2,103.6h2.6c0.4,0,0.8,0.4,0.8,0.8v9.9c0,0.4-0.4,0.8-0.8,0.8h-2.6 c-0.4,0-0.8-0.4-0.8-0.8v-9.9C507.4,103.9,507.7,103.6,508.2,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_469",
    className: "st2",
    d: "M550.8,103.6h2.6c0.4,0,0.8,0.4,0.8,0.8v9.9c0,0.4-0.4,0.8-0.8,0.8h-2.6 c-0.4,0-0.8-0.4-0.8-0.8v-9.9C550,103.9,550.3,103.6,550.8,103.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_470",
    className: "st3",
    d: "M416.9,121.1h145.3c0.8,0,1.5,0.7,1.5,1.5v2.1c0,0.8-0.7,1.5-1.5,1.5H416.9 c-0.8,0-1.5-0.7-1.5-1.5v-2.1C415.4,121.8,416.1,121.1,416.9,121.1z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ellipse_111_00000123419119855122292310000014837848159403526591_",
    cx: -451.7228,
    cy: 748.0036,
    r: 1.972,
    gradientTransform: "matrix(63.1706 0 0 -14.4962 29024.6191 11174.5059)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.984
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.937
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.855
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.216
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_111",
    style: {
      opacity: 0.7,
      fill: "url(#Ellipse_111_00000123419119855122292310000014837848159403526591_)",
      enableBackground: "new"
    },
    cx: 490.8,
    cy: 335,
    rx: 132.2,
    ry: 31.7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    transform: "translate(-114.787 -104.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    className: "st5",
    d: "M180.8,197.2c1.3,6.1,2.8,13.3,4.1,16.6s7.1,15.8,8.4,22.1s4.1,18.4,4.5,24.9 s-0.1,15.8-0.3,21.7s-2.8,12.9-3.1,16.9c-0.5,5.1-2.2,10.1-4.9,14.5c-2.3,3.5-5,6.8-8,9.7c-1.1,1.2-2.8,1.5-4.3,0.8l7.1-36.2 l-9.7-73.8L180.8,197.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    className: "st6",
    d: "M177.4,181.1c1.1,0.1,2.2,0.3,3.2,0.7c0.9,0.3,1.1,1.7,0.8,3.7s-0.5,13.2-0.5,16.8 s1.2,8.5,2.7,13.7s3.9,18.4,5.1,23.4s5.1,18.4,5.9,25s1.3,15.6,1.3,16.9s1.5,2.9,2.7,3.6c1.4,0.9,2.6,2.1,3.3,3.6 c1.2,2,4.8,6.4,5.7,7.6s2.4,2,2.4,2.8s-0.7,3.6-1.3,4.3s-2.5-0.1-3.7-1.2c-2.5-1.7-5.3-2.8-8.2-3.5c-1.5-0.3-3,0.2-4,1.3 c-0.9,1.1-1.6,7.8-3.3,11s-8.8,13.4-9.6,14.8s-2.4,1.7-4.3,1.5c-1.7-0.4-3.2-1.1-4.7-2c-0.7-0.4,0.5-2.7,0.9-3.9s0.3-5.7-1.7-7.8 s-6.3-10.4-7.3-12.6s-2.4-5.7-2.3-14.4s1.7-12.6,1.9-19.8s-1.9-24.5-4.4-31.1s-4.3-13-2.4-19.2s8.1-10.5,10.6-12.5 s3.3-3.5,4.8-7.7s3.6-9.7,3.6-11.4S175,180.8,177.4,181.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    className: "st7",
    d: "M180.9,201.2c-1.9,5.9-1.9,12.4-1.3,18.5c0.4,3.5,1.2,6.9,2.1,10.2c0.7,3.3,1.1,6.7,1.3,10.1 c0.7,7.7,2.8,15.2,4,22.8c0.8,5.1,0.9,10.7,3.3,15.4c1.5,2.7,3.9,4.7,6.9,5.6c-0.8-0.7-1.2-1.6-1.4-2.6c0-1.3-0.5-10.2-1.3-16.9 s-4.7-20-5.9-25s-3.6-18.2-5.1-23.4s-2.7-10.1-2.7-13.7C180.9,201.9,180.9,201.6,180.9,201.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    className: "st7",
    d: "M201.5,299.8c-1-1.7-2.4-2.3-4.3-2.6c-3.2-0.6-7-0.8-8.5,2.6c-1.1,2.5-1.1,5.5-1.2,8.2 c-0.1,2-0.2,4-0.3,6c0.9-1.3,1.6-2.5,2-3.3c1.7-3.2,2.4-10,3.3-11c1-1.1,2.5-1.6,4-1.3c1.8,0.3,3.5,0.9,5.1,1.7 C201.7,300,201.6,299.9,201.5,299.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    className: "st7",
    d: "M176.2,325.9c-1.8-0.6-3.1-1.9-4.8-2.7c-0.2-0.1-0.3-0.1-0.4-0.2c-0.4,0.9-0.6,1.8-0.2,2 c1.4,0.9,3,1.6,4.7,2c1.2,0.3,2.4,0,3.5-0.6C178,326.3,177.1,326.1,176.2,325.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    className: "st7",
    d: "M176.9,305.8c-0.7-1.1-2.2-3.1-3.5-1.9c-0.4,0.4-1,0.6-1.6,0.5c-1.6,1.2-2.9,3-4.4,4.4 c-0.1,0.1-0.2,0.2-0.3,0.2c0.8,1.5,1.8,2.9,2.8,4.2c1.2,1.5,1.8,3.4,1.9,5.3c1.6,0.1,3.1-0.5,4.1-1.7c1.4-1.7,2.2-3.8,2.2-6 C178.3,309.1,177.9,307.3,176.9,305.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    className: "st8",
    d: "M173.6,301.7c3.3,1.1,3.9,6.9,0.9,10.2s-6.5,4.8-8.1,6.3c-1.2,1.2-2.3,2.4-3.3,3.7 c-1.5-6.5-0.5-13.2,1.7-16.6C167.2,301.7,170.4,300.7,173.6,301.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    className: "st9",
    d: "M183.2,164.5c0-3.1-2.5-5.5-5.5-5.5c-3.1,0-5.5,2.5-5.5,5.5c0,2.4,1.5,4.5,3.8,5.3 c0,0,0,0,0,0.1v4.1c0,0.6,0.5,1.1,1.1,1.2v16h1.6v-16c0.6-0.1,1.1-0.6,1.1-1.2v-4.1c0-0.1,0-0.1,0-0.2 C181.8,168.8,183.2,166.7,183.2,164.5z M177.7,168c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5 C181.2,166.4,179.6,168,177.7,168L177.7,168z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    className: "st9",
    d: "M173.6,188.1l7.6,1.2c0.3,0.1,0.6,0.4,0.6,0.7l-0.3,5.5c0,0.4-0.3,0.6-0.7,0.6 c0,0-0.1,0-0.1,0l-8.9-1.8c-0.4-0.1-0.6-0.4-0.5-0.8c0,0,0,0,0-0.1l1.6-4.9C173,188.2,173.3,188,173.6,188.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    className: "st5",
    d: "M231,197.2c1.3,6.1,2.8,13.3,4.1,16.6s7,15.8,8.4,22.1s4.1,18.4,4.5,24.9s-0.1,15.8-0.3,21.7 s-2.8,12.9-3.1,16.9c-0.5,5.1-2.2,10.1-4.9,14.5c-2.3,3.5-5,6.8-8,9.7c-1.1,1.2-2.8,1.5-4.3,0.8l7-36.2l-9.7-73.8L231,197.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    className: "st6",
    d: "M227.7,181.1c1.1,0.1,2.2,0.3,3.2,0.7c0.9,0.3,1.1,1.7,0.8,3.7s-0.5,13.2-0.5,16.8 s1.2,8.5,2.7,13.7s3.9,18.4,5.1,23.4s5.1,18.4,5.9,25s1.3,15.6,1.3,16.9s1.5,2.9,2.7,3.6c1.4,0.9,2.6,2.1,3.3,3.6 c1.2,2,4.8,6.4,5.7,7.6s2.4,2,2.4,2.8s-0.7,3.6-1.3,4.3s-2.5-0.1-3.7-1.2c-2.5-1.7-5.3-2.8-8.2-3.5c-1.5-0.3-3,0.2-4,1.3 c-0.9,1.1-1.6,7.8-3.3,11s-8.8,13.4-9.6,14.8s-2.4,1.7-4.3,1.5c-1.7-0.4-3.2-1.1-4.7-2c-0.7-0.4,0.5-2.7,0.9-3.9s0.3-5.7-1.7-7.8 s-6.3-10.4-7.3-12.6s-2.4-5.7-2.3-14.4s1.7-12.6,1.9-19.8s-1.9-24.5-4.4-31.1s-4.3-13-2.4-19.2s8.1-10.5,10.6-12.5 s3.3-3.5,4.8-7.7s3.6-9.7,3.6-11.4S225.3,180.8,227.7,181.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    className: "st7",
    d: "M231.2,201.2c-1.9,5.9-1.9,12.4-1.3,18.5c0.4,3.5,1.2,6.9,2.1,10.2c0.7,3.3,1.1,6.7,1.3,10.1 c0.7,7.7,2.8,15.2,4,22.8c0.8,5.1,0.9,10.7,3.3,15.4c1.5,2.7,3.9,4.7,6.9,5.6c-0.8-0.7-1.2-1.6-1.4-2.6c0-1.3-0.5-10.2-1.3-16.9 s-4.7-20-5.9-25s-3.6-18.2-5.1-23.4s-2.7-10.1-2.7-13.7C231.2,201.9,231.2,201.6,231.2,201.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    className: "st7",
    d: "M251.8,299.8c-1-1.7-2.4-2.3-4.3-2.6c-3.2-0.6-7-0.8-8.5,2.6c-1.1,2.5-1.1,5.5-1.2,8.2 c-0.1,2-0.2,4-0.3,6c0.9-1.3,1.6-2.5,2-3.3c1.7-3.2,2.4-10,3.3-11c1-1.1,2.5-1.6,4-1.3c1.8,0.3,3.5,0.9,5.1,1.7 C251.9,300,251.9,299.9,251.8,299.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    className: "st7",
    d: "M226.5,325.9c-1.8-0.6-3.1-1.9-4.8-2.7c-0.2-0.1-0.3-0.1-0.4-0.2c-0.4,0.9-0.6,1.8-0.2,2 c1.4,0.9,3,1.6,4.7,2c1.2,0.3,2.4,0,3.5-0.6C228.3,326.3,227.4,326.1,226.5,325.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    className: "st7",
    d: "M227.2,305.8c-0.7-1.1-2.2-3.1-3.5-1.9c-0.4,0.4-1,0.6-1.6,0.5c-1.6,1.2-2.9,3-4.4,4.4 c-0.1,0.1-0.2,0.2-0.3,0.2c0.8,1.5,1.8,2.9,2.8,4.2c1.2,1.5,1.8,3.4,1.9,5.3c1.6,0.1,3.1-0.5,4.1-1.7c1.4-1.7,2.2-3.8,2.2-6 C228.6,309.1,228.2,307.3,227.2,305.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    className: "st8",
    d: "M223.9,301.7c3.3,1.1,3.9,6.9,0.9,10.2s-6.5,4.8-8.1,6.3c-1.2,1.2-2.3,2.4-3.3,3.7 c-1.5-6.5-0.5-13.2,1.7-16.6C217.5,301.7,220.7,300.7,223.9,301.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    className: "st9",
    d: "M233.5,164.5c0-3-2.5-5.5-5.5-5.5c-3,0-5.5,2.5-5.5,5.5c0,2.4,1.5,4.5,3.8,5.2c0,0,0,0,0,0.1 v4.1c0,0.6,0.5,1.1,1.1,1.2v16h1.6v-16c0.6-0.1,1.1-0.6,1.1-1.2v-4.1c0-0.1,0-0.1,0-0.2C232.1,168.8,233.5,166.7,233.5,164.5z  M228,168c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C231.5,166.4,229.9,168,228,168z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    className: "st9",
    d: "M223.9,188.1l7.6,1.2c0.3,0.1,0.6,0.4,0.6,0.7l-0.3,5.5c0,0.4-0.3,0.6-0.7,0.6 c0,0-0.1,0-0.1,0l-8.9-1.8c-0.4-0.1-0.6-0.4-0.5-0.8c0,0,0,0,0-0.1l1.6-4.9C223.2,188.2,223.6,188,223.9,188.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    className: "st5",
    d: "M281.3,197.2c1.3,6.1,2.8,13.3,4.1,16.6s7,15.8,8.4,22.1s4.1,18.4,4.5,24.9 s-0.1,15.8-0.3,21.7s-2.8,12.9-3.1,16.9c-0.5,5.1-2.2,10.1-4.9,14.5c-2.3,3.5-5,6.8-8,9.7c-1.1,1.2-2.8,1.5-4.3,0.8l7-36.2 l-9.7-73.8L281.3,197.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    className: "st6",
    d: "M278,181.1c1.1,0.1,2.2,0.3,3.2,0.7c0.9,0.3,1.1,1.7,0.8,3.7s-0.5,13.2-0.5,16.8 s1.2,8.5,2.7,13.7s3.9,18.4,5.1,23.4s5.1,18.4,5.9,25s1.3,15.6,1.3,16.9s1.5,2.9,2.7,3.6c1.4,0.9,2.6,2.1,3.3,3.6 c1.2,2,4.8,6.4,5.7,7.6s2.4,2,2.4,2.8s-0.7,3.6-1.3,4.3s-2.5-0.1-3.7-1.2c-2.5-1.7-5.3-2.8-8.2-3.5c-1.5-0.3-3,0.2-4,1.3 c-0.9,1.1-1.6,7.8-3.3,11s-8.8,13.4-9.6,14.8s-2.4,1.7-4.3,1.5c-1.7-0.4-3.2-1.1-4.7-2c-0.7-0.4,0.5-2.7,0.9-3.9s0.3-5.7-1.7-7.8 s-6.3-10.4-7.3-12.6s-2.4-5.7-2.3-14.4s1.7-12.6,1.9-19.8s-1.9-24.5-4.4-31.1s-4.3-13-2.4-19.2c1.9-6.1,8.1-10.5,10.6-12.5 s3.3-3.5,4.8-7.7s3.6-9.7,3.6-11.4S275.6,180.8,278,181.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    className: "st7",
    d: "M281.5,201.2c-1.9,5.9-1.9,12.4-1.3,18.5c0.4,3.5,1.2,6.9,2.1,10.2c0.7,3.3,1.1,6.7,1.3,10.1 c0.7,7.7,2.8,15.2,4,22.8c0.8,5.1,0.9,10.7,3.3,15.4c1.5,2.7,3.9,4.7,6.9,5.6c-0.8-0.7-1.2-1.6-1.4-2.6c0-1.3-0.5-10.2-1.3-16.9 s-4.7-20-5.9-25s-3.6-18.2-5.1-23.4s-2.7-10.1-2.7-13.7C281.5,201.9,281.5,201.6,281.5,201.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    className: "st7",
    d: "M302.1,299.8c-1-1.7-2.4-2.3-4.3-2.6c-3.2-0.6-7-0.8-8.5,2.6c-1.1,2.5-1.1,5.5-1.2,8.2 c-0.1,2-0.2,4-0.3,6c0.9-1.3,1.6-2.5,2-3.3c1.7-3.2,2.4-10,3.3-11c1-1.1,2.5-1.6,4-1.3c1.8,0.3,3.5,0.9,5.1,1.7 C302.2,300,302.2,299.9,302.1,299.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    className: "st7",
    d: "M276.8,325.9c-1.8-0.6-3.1-1.9-4.8-2.7c-0.2-0.1-0.3-0.1-0.4-0.2c-0.4,0.9-0.6,1.8-0.2,2 c1.4,0.9,3,1.6,4.7,2c1.2,0.3,2.4,0,3.5-0.6C278.6,326.3,277.7,326.1,276.8,325.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    className: "st7",
    d: "M277.5,305.8c-0.7-1.1-2.2-3.1-3.5-1.9c-0.4,0.4-1,0.6-1.6,0.5c-1.6,1.2-2.9,3-4.4,4.4 c-0.1,0.1-0.2,0.2-0.3,0.2c0.8,1.5,1.8,2.9,2.8,4.2c1.2,1.5,1.8,3.4,1.9,5.3c1.6,0.1,3.1-0.5,4.1-1.7c1.4-1.7,2.2-3.8,2.2-6 C278.9,309.1,278.4,307.3,277.5,305.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    className: "st8",
    d: "M274.1,301.7c3.3,1.1,3.9,6.9,0.9,10.2s-6.5,4.8-8.1,6.3c-1.2,1.2-2.3,2.4-3.3,3.7 c-1.5-6.5-0.5-13.2,1.7-16.6C267.7,301.7,270.9,300.7,274.1,301.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    className: "st9",
    d: "M283.8,164.5c0-3.1-2.5-5.5-5.5-5.5c-3.1,0-5.5,2.5-5.5,5.5c0,2.4,1.5,4.5,3.8,5.3 c0,0,0,0,0,0.1v4.1c0,0.6,0.5,1.1,1.1,1.2v16h1.6v-16c0.6-0.1,1.1-0.6,1.1-1.2v-4.1c0-0.1,0-0.1,0-0.2 C282.4,168.8,283.8,166.7,283.8,164.5z M278.3,168c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5 C281.8,166.4,280.2,168,278.3,168z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    className: "st9",
    d: "M274.2,188.1l7.6,1.2c0.3,0.1,0.6,0.4,0.6,0.7l-0.3,5.5c0,0.4-0.3,0.6-0.7,0.6 c0,0-0.1,0-0.1,0l-8.9-1.8c-0.4-0.1-0.6-0.4-0.5-0.8c0,0,0,0,0-0.1l1.6-4.9C273.5,188.2,273.8,188,274.2,188.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    className: "st5",
    d: "M331.6,197.2c1.3,6.1,2.8,13.3,4.1,16.6s7,15.8,8.4,22.1s4.1,18.4,4.5,24.9 s-0.1,15.8-0.3,21.7s-2.8,12.9-3.1,16.9c-0.5,5.1-2.2,10.1-4.9,14.5c-2.3,3.5-5,6.8-8,9.7c-1.1,1.2-2.8,1.5-4.3,0.8l7-36.2 l-9.7-73.8L331.6,197.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    className: "st6",
    d: "M328.3,181.1c1.1,0.1,2.2,0.3,3.2,0.7c0.9,0.3,1.1,1.7,0.8,3.7s-0.5,13.2-0.5,16.8 s1.2,8.5,2.7,13.7s3.9,18.4,5.1,23.4s5.1,18.4,5.9,25s1.3,15.6,1.3,16.9s1.5,2.9,2.7,3.6c1.4,0.9,2.6,2.1,3.3,3.6 c1.2,2,4.8,6.4,5.7,7.6s2.4,2,2.4,2.8s-0.7,3.6-1.3,4.3s-2.5-0.1-3.7-1.2c-2.5-1.7-5.3-2.8-8.2-3.5c-1.5-0.3-3,0.2-4,1.3 c-0.9,1.1-1.6,7.8-3.3,11s-8.8,13.4-9.6,14.8s-2.4,1.7-4.3,1.5c-1.7-0.4-3.2-1.1-4.7-2c-0.7-0.4,0.5-2.7,0.9-3.9s0.3-5.7-1.7-7.8 s-6.3-10.4-7.3-12.6s-2.4-5.7-2.3-14.4s1.7-12.6,1.9-19.8s-1.9-24.5-4.4-31.1s-4.3-13-2.4-19.2s8.1-10.5,10.6-12.5 s3.3-3.5,4.8-7.7s3.6-9.7,3.6-11.4S325.9,180.8,328.3,181.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    className: "st7",
    d: "M331.7,201.2c-1.9,5.9-1.9,12.4-1.3,18.5c0.4,3.5,1.2,6.9,2.1,10.2c0.7,3.3,1.1,6.7,1.3,10.1 c0.7,7.7,2.8,15.2,4,22.8c0.8,5.1,0.9,10.7,3.3,15.4c1.4,2.7,3.9,4.7,6.9,5.6c-0.8-0.7-1.2-1.6-1.4-2.6c0-1.3-0.5-10.2-1.3-16.9 s-4.7-20-5.9-25s-3.6-18.2-5.1-23.4s-2.7-10.1-2.7-13.7C331.7,201.9,331.7,201.6,331.7,201.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    className: "st7",
    d: "M352.4,299.8c-1-1.7-2.4-2.3-4.3-2.6c-3.2-0.6-7-0.8-8.5,2.6c-1.1,2.5-1.1,5.5-1.2,8.2 c-0.1,2-0.2,4-0.3,6c0.9-1.3,1.6-2.5,2-3.3c1.7-3.2,2.4-10,3.3-11c1-1.1,2.5-1.6,4-1.3c1.8,0.3,3.5,0.9,5.1,1.7 C352.5,300,352.4,299.9,352.4,299.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    className: "st7",
    d: "M327.1,325.9c-1.8-0.6-3.1-1.9-4.8-2.7c-0.2-0.1-0.3-0.1-0.4-0.2c-0.4,0.9-0.6,1.8-0.2,2 c1.4,0.9,3,1.6,4.7,2c1.2,0.3,2.4,0,3.5-0.6C328.8,326.3,328,326.1,327.1,325.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    className: "st7",
    d: "M327.8,305.8c-0.7-1.1-2.2-3.1-3.5-1.9c-0.4,0.4-1,0.6-1.6,0.5c-1.6,1.2-2.9,3-4.4,4.4 c-0.1,0.1-0.2,0.2-0.3,0.2c0.8,1.5,1.8,2.9,2.8,4.2c1.2,1.5,1.8,3.4,1.9,5.3c1.6,0.1,3.1-0.5,4.1-1.7c1.4-1.7,2.2-3.8,2.2-6 C329.2,309.1,328.7,307.3,327.8,305.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    className: "st8",
    d: "M324.4,301.7c3.3,1.1,3.9,6.9,0.9,10.2s-6.5,4.8-8.1,6.3c-1.2,1.2-2.3,2.4-3.3,3.7 c-1.5-6.5-0.5-13.2,1.7-16.6C318,301.7,321.2,300.7,324.4,301.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    className: "st9",
    d: "M334.1,164.5c0-3.1-2.5-5.5-5.5-5.5c-3.1,0-5.5,2.5-5.5,5.5c0,2.4,1.5,4.5,3.8,5.3 c0,0,0,0,0,0.1v4.1c0,0.6,0.5,1.1,1.1,1.2v16h1.6v-16c0.6-0.1,1.1-0.6,1.1-1.2v-4.1c0-0.1,0-0.1,0-0.2 C332.7,168.8,334.1,166.7,334.1,164.5z M328.5,168c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5 C332.1,166.4,330.5,168,328.5,168z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    className: "st9",
    d: "M324.4,188.1l7.6,1.2c0.3,0.1,0.6,0.4,0.6,0.7l-0.3,5.5c0,0.4-0.3,0.6-0.7,0.6 c0,0-0.1,0-0.1,0l-8.9-1.8c-0.4-0.1-0.6-0.4-0.5-0.8c0,0,0,0,0-0.1l1.6-4.9C323.8,188.2,324.1,188,324.4,188.1z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    transform: "translate(-114.787 -104.338)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_401",
    x: 239,
    y: 291.8,
    className: "st2",
    width: 63.1,
    height: 41.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_402",
    className: "st10",
    d: "M239.3,170.2h62.4c0.6,0,1.1,0.5,1.1,1.1V294c0,0.6-0.5,1.1-1.1,1.1h-62.4 c-0.6,0-1.1-0.5-1.1-1.1V171.2C238.3,170.7,238.7,170.2,239.3,170.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_403",
    x: 238.3,
    y: 250.7,
    className: "st11",
    width: 64.5,
    height: 25.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_434"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_404",
    x: 249,
    y: 202.9,
    className: "st12",
    width: 44.5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_405",
    x: 280.4,
    y: 206,
    className: "st13",
    width: 9.9,
    height: 17.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_406",
    x: 252.9,
    y: 206,
    className: "st14",
    width: 24.2,
    height: 17.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_407",
    x: 249,
    y: 253.3,
    className: "st15",
    width: 20.9,
    height: 19.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_435"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_408",
    x: 252,
    y: 255.8,
    className: "st12",
    width: 5.6,
    height: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_409",
    x: 260.9,
    y: 255.8,
    className: "st12",
    width: 5.6,
    height: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_410",
    x: 252,
    y: 264,
    className: "st12",
    width: 5.6,
    height: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_411",
    x: 260.9,
    y: 264,
    className: "st12",
    width: 5.6,
    height: 5.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_412",
    className: "st15",
    d: "M274.8,253.2h6.4c1.2,0,2.1,0.9,2.1,2.1v0.6c0,1.2-0.9,2.1-2.1,2.1h-6.4 c-1.2,0-2.1-0.9-2.1-2.1v-0.6C272.7,254.1,273.7,253.2,274.8,253.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_413",
    className: "st15",
    d: "M274.8,260.5h6.4c1.2,0,2.1,0.9,2.1,2.1v0.6c0,1.2-0.9,2.1-2.1,2.1h-6.4 c-1.2,0-2.1-0.9-2.1-2.1v-0.6C272.7,261.4,273.7,260.5,274.8,260.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_414",
    className: "st15",
    d: "M274.8,267.8h6.4c1.2,0,2.1,0.9,2.1,2.1v0.6c0,1.2-0.9,2.1-2.1,2.1h-6.4 c-1.2,0-2.1-0.9-2.1-2.1v-0.6C272.7,268.8,273.7,267.8,274.8,267.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_415",
    className: "st12",
    d: "M289.2,252.2h1.3c1.7,0,3.1,1.4,3.1,3.1v16.3c0,1.7-1.4,3.1-3.1,3.1h-1.3 c-1.7,0-3.1-1.4-3.1-3.1v-16.3C286.1,253.6,287.5,252.2,289.2,252.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_416",
    className: "st9",
    d: "M288.2,238.4h3.3l0,0v30.4c0,0.9-0.7,1.7-1.7,1.7l0,0l0,0c-0.9,0-1.7-0.7-1.7-1.7V238.4 L288.2,238.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    className: "st13",
    cx: 289.9,
    cy: 238.2,
    r: 5.7
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    transform: "translate(-114.787 -104.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    x: 195.2,
    y: 151.6,
    className: "st2",
    width: 3.4,
    height: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    x: 246.1,
    y: 151.6,
    className: "st2",
    width: 3.4,
    height: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_419",
    x: 297,
    y: 151.6,
    className: "st2",
    width: 3.4,
    height: 10.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    className: "st12",
    d: "M331.6,165.1H172.6c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2h158.9c4.5,0,8.2,3.7,8.2,8.2 S336.1,165.1,331.6,165.1z M172.6,152.8c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2l0,0h158.9c2.3,0,4.2-1.9,4.2-4.2s-1.9-4.2-4.2-4.2 H172.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_442"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    className: "st2",
    cx: 172.6,
    cy: 157,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    className: "st2",
    cx: 331.6,
    cy: 157,
    r: 6.2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    className: "st13",
    cx: 172.6,
    cy: 157,
    r: 2.7
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    className: "st13",
    cx: 331.6,
    cy: 157,
    r: 2.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHappensAtButchery);
export default __webpack_public_path__ + "static/media/img-happens-at-butchery.e7c5a19c2c4be57622b210e84a1e3966.svg";
export { ForwardRef as ReactComponent };